import styled from 'styled-components';

export const StyleOptionContainer = styled.div`
  display: flex;
  width: 100%;

  > div {
    flex-grow: 1;
  }

  p {
    margin-bottom: 0.5rem;
  }

  .ant-select {
    width: 100%;
  }
`;
